import { useState, useEffect } from "react";
import { AdsListStatus } from "../../../../../types/api/ads";
import { filterItems } from "../../UserAnnouncements+Data";
import { PriceFormModal, formatPriceRange } from './PriceFormModal';
import { DateFormModal, formatDateRange } from './DateFormModal';
import { Stack, ActionList, ActionMenu, IconButton, Button } from '@primer/react';
import { FilterIcon, NumberIcon, ClockIcon, ChevronRightIcon } from '@primer/octicons-react'

interface AdsFilterFormModalProps {
    filterOpened: boolean;
    setFilterOpened: (value: boolean) => void;

    priceFilterOpened: boolean;
    setPriceFilterOpened: (value: boolean) => void;

    dateFilterOpened: boolean;
    setDateFilterOpened: (value: boolean) => void;

    selectedFilter: AdsListStatus | undefined;
    setSelectedFilter: (value: AdsListStatus | undefined) => void;

    fromPrice: string;
    setFromPrice: (value: string) => void;
    toPrice: string;
    setToPrice: (value: string) => void;
    fromDate: string;
    setFromDate: (value: string) => void;
    toDate: string;
    setToDate: (value: string) => void;
    onDismiss: () => void;
    onApply: () => void;
}

const AdsFilterFormModal: React.FC<AdsFilterFormModalProps> = ({
    filterOpened,
    setFilterOpened,

    priceFilterOpened,
    setPriceFilterOpened,
    dateFilterOpened,
    setDateFilterOpened,

    selectedFilter,
    setSelectedFilter,

    fromPrice,
    setFromPrice,
    toPrice,
    setToPrice,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    onDismiss,
    onApply
}) => {
    const selectedIndex = filterItems.findIndex(item => item.filter === selectedFilter);

    const fromPriceNumber = parseFloat(fromPrice);
    const toPriceNumber = parseFloat(toPrice);

    const priceFormError =
        fromPrice !== '' &&
        toPrice !== '' &&
        !isNaN(fromPriceNumber) &&
        !isNaN(toPriceNumber) &&
        fromPriceNumber > toPriceNumber;

    const dateFormError =
        fromDate !== '' &&
        toDate !== '' &&
        new Date(fromDate) > new Date(toDate);

    const priceModalDidDismiss = () => {
        setPriceFilterOpened(false)
        setFilterOpened(true)
    }

    const dateModalDidDismiss = () => {
        setDateFilterOpened(false)
        setFilterOpened(true)
    }

    const handleDismiss = () => {
        setFilterOpened(false);
        onDismiss()
    }

    const handleApply = () => {
        setFilterOpened(false);
        onApply()
    }

    return (
        <>
            <PriceFormModal
                priceFilterOpened={priceFilterOpened}
                setPriceFilterOpened={setPriceFilterOpened}
                fromPrice={fromPrice}
                setFromPrice={setFromPrice}
                toPrice={toPrice}
                setToPrice={setToPrice}
                priceFormError={priceFormError}
                onDismiss={priceModalDidDismiss}
                onApply={priceModalDidDismiss}
            />

            <DateFormModal
                dateFilterOpened={dateFilterOpened}
                setDateFilterOpened={setDateFilterOpened}
                fromDate={fromDate}
                setFromDate={setFromDate}
                toDate={toDate}
                setToDate={setToDate}
                dateFormError={dateFormError}
                onDismiss={dateModalDidDismiss}
                onApply={dateModalDidDismiss}
                isShowBackButton={true}
            />

            <ActionMenu open={filterOpened} onOpenChange={setFilterOpened}>
                <ActionMenu.Anchor>
                    <IconButton icon={FilterIcon} aria-label="Фильтр" />
                </ActionMenu.Anchor>
                <ActionMenu.Overlay className="!w-[260px]">
                    <ActionList
                        selectionVariant="single"
                        role="menu"
                        aria-label="Item"
                        className="!w-[260px]"
                    >
                        {filterItems.map((item, index) => (
                            <ActionList.Item
                                key={index}
                                role="menuitemradio"
                                selected={index === selectedIndex}
                                aria-checked={index === selectedIndex}
                                onSelect={() => setSelectedFilter(item.filter)}
                            >
                                <Stack align="center" direction="horizontal" gap='none'>
                                    <div className='text-[#59636E] mr-2' >{item.icon}</div>
                                    {item.label}
                                </Stack>
                            </ActionList.Item>
                        ))}
                        <ActionList.Divider />
                        <ActionList.Group>
                            <ActionList.Item
                                key='price'
                                onSelect={() => setPriceFilterOpened(true)}>
                                <ActionList.LeadingVisual>
                                    <NumberIcon />
                                </ActionList.LeadingVisual>
                                <p className='font-normal' >По цене</p>
                                <ActionList.TrailingVisual><ChevronRightIcon /></ActionList.TrailingVisual>
                                <ActionList.Description variant="block">
                                    {formatPriceRange(fromPrice, toPrice)}
                                </ActionList.Description>
                            </ActionList.Item>


                            <ActionList.Item
                                key='date'
                                onSelect={() => setDateFilterOpened(true)}>
                                <ActionList.LeadingVisual>
                                    <ClockIcon />
                                </ActionList.LeadingVisual>
                                <p className='font-normal whitespace-pre-line'>По дате размещения</p>
                                <ActionList.TrailingVisual><ChevronRightIcon /></ActionList.TrailingVisual>
                                <ActionList.Description variant="block">
                                    {formatDateRange(fromDate, toDate)}
                                </ActionList.Description>
                            </ActionList.Item>
                        </ActionList.Group>

                        <Stack direction="horizontal" gap='normal' className='block mt-4 ml-[66px]'>
                            <Button
                                onClick={handleDismiss}
                                size='small'
                                variant="default">
                                Очистить
                            </Button>
                            <Button
                                onClick={handleApply}
                                size='small'
                                variant="primary">
                                Применить
                            </Button>
                        </Stack>

                    </ActionList>
                </ActionMenu.Overlay>
            </ActionMenu>
        </>
    )
}


export default AdsFilterFormModal